import React from 'react'
import { Grid } from '@material-ui/core'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'

import MainTemplate from '../../templates/MainTemplate'
import Filters from '../../containers/cartChange/overview/filters/Index'

import CounterCartChangeOpened from '../../containers/cartChange/overview/widgets/CounterCartChangeOpened'
import CounterCartChangeAccepted from '../../containers/cartChange/overview/widgets/CounterCartChangeAccepted'
import CounterCartChangedDismissed from '../../containers/cartChange/overview/widgets/CounterCartChangedDismissed'

import MapEvents from '../../containers/cartChange/overview/MapEvents'
import UserComparisonDecision from '../../containers/cartChange/overview/charts/UserComparisonDecision'
import PharmaciesReceivedUsers from '../../containers/cartChange/overview/charts/PharmaciesReceivedUsers'
import PharmaciesLoseUsers from '../../containers/cartChange/overview/charts/PharmaciesLoseUsers'
import AcceptanceRefuseAbandon from '../../containers/cartChange/overview/charts/AcceptanceRefuseAbandon'
import CartChangeOpenedStates from '../../containers/cartChange/overview/charts/CartChangeOpenedStates'
import CartChangeAcceptedUsers from '../../containers/cartChange/overview/charts/CartChangeAcceptedUsers'
import CartChangeDismissedUsers from '../../containers/cartChange/overview/charts/CartChangeDismissedUsers'
import CartChangeOpenedUsers from '../../containers/cartChange/overview/charts/CartChangeOpenedUsers'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      marginTop: theme.spacing(2)
    }
  })
)

const CartChange = (): JSX.Element => {
  const classes = useStyles()

  return (
    <MainTemplate>
      <Filters />

      <Grid item container spacing={1} className={classes.container}>
        <Grid item sm={12} md={4} xs={12}>
          <CounterCartChangeOpened />
        </Grid>
        <Grid item sm={12} md={4} xs={12}>
          <CounterCartChangeAccepted />
        </Grid>
        <Grid item sm={12} md={4} xs={12}>
          <CounterCartChangedDismissed />
        </Grid>
      </Grid>

      <Grid item container spacing={1} className={classes.container}>
        <Grid item sm={12} md={12} xs={12}>
            <MapEvents />
        </Grid>
      </Grid>

      <Grid item container spacing={1} className={classes.container}>
        <Grid item sm={12} md={12} xs={12}>
            <UserComparisonDecision />
        </Grid>
      </Grid>

      <Grid item container spacing={1} className={classes.container}>
        <Grid item sm={12} md={6} xs={12}>
            <PharmaciesReceivedUsers />
        </Grid>
        <Grid item sm={12} md={6} xs={12}>
            <PharmaciesLoseUsers />
        </Grid>
      </Grid>

      <Grid item container spacing={1} className={classes.container}>
        <Grid item lg={6} md={6} xs={12}>
            <AcceptanceRefuseAbandon />
        </Grid>
        <Grid item lg={6} md={6} xs={12}>
            <CartChangeOpenedStates />
        </Grid>
      </Grid>

      <Grid item container spacing={1} className={classes.container}>
        <Grid item lg={4} md={4} xs={12}>
            <CartChangeAcceptedUsers />
        </Grid>
        <Grid item lg={4} md={4} xs={12}>
            <CartChangeDismissedUsers />
        </Grid>
        <Grid item lg={4} md={4} xs={12}>
            <CartChangeOpenedUsers />
        </Grid>
      </Grid>
      {/* <Grid item container spacing={1} className={classes.container}>
        <Grid item lg={12} md={12} xs={12}>
            <MostOpenedUsers />
        </Grid>
      </Grid> */}
    </MainTemplate>
  )
}

export default CartChange
